import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Logo } from './shared';
import { useSiteConfig } from '../../lib/siteConfig';
import { CONTACT_EMAIL, IMPRESSUM_URL } from '../../config/site';

const linkCls = 'rounded text-sm text-white/70 transition-colors hover:text-white';

export const Footer = () => {
  const { brand_name } = useSiteConfig();
  return (
    <footer className="border-t border-line bg-paper py-14" data-testid="site-footer">
      <Container>
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
          <Logo testId="footer-logo" />
          <nav className="flex flex-wrap gap-x-6 gap-y-3" aria-label="Rechtliches">
            <a href={IMPRESSUM_URL} className={linkCls} data-testid="footer-impressum-link">Impressum</a>
            <Link to="/datenschutz" className={linkCls} data-testid="footer-datenschutz-link">Datenschutz</Link>
            <Link to="/agb" className={linkCls} data-testid="footer-agb-link">AGB</Link>
            <a href={`mailto:${CONTACT_EMAIL}`} className={linkCls} data-testid="footer-email-link">{CONTACT_EMAIL}</a>
          </nav>
        </div>
        <p className="mt-10 max-w-3xl text-xs leading-relaxed text-white/50">
          Hinweis: Diese Website dient ausschließlich Informations- und Bildungszwecken. Es handelt sich nicht um eine Anlageberatung im Sinne des WpHG. Investitionen in Aktien und andere Wertpapiere sind mit Risiken bis hin zum Totalverlust verbunden.
        </p>
        <p className="mt-6 text-xs text-white/50" data-testid="footer-copyright">© {new Date().getFullYear()} {brand_name}</p>
      </Container>
    </footer>
  );
};
